import { Tag } from 'antd';

interface ResponseCodeProps {
  code: number;
}

export const ResponseCode = ({ code }: ResponseCodeProps) => {
  if (code == 0) return null;

  let color = 'green';

  if (code >= 300 && code < 400) color = 'yellow';
  if (code >= 400) color = 'red';

  return <Tag color={color}>{code}</Tag>;
};
